import useAppQuery from 'core/query-client/useAppQuery';
import { getSpecialtySpacesRooms } from 'shared/api/specialty-spaces/http';

const useSpecialtySpacesRoomsQuery = () =>
  useAppQuery('specialty-spaces-rooms', getSpecialtySpacesRooms, {
    refetchOnMount: false,
    cacheTime: Infinity
  });

export default useSpecialtySpacesRoomsQuery;
